export default __webpack_public_path__ + "static/blob9-5b2972541aeb4660c4d91d0765a85e43.svg";